<template>
  <b-modal
    id="modal_imporatacao_doc"
    ref="modal_imporatacao_doc"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModal"
  >
    <div class="col-md-12 col-sm-12">
      <label>Tipo do documento</label>
      <multiselect
        v-model="tpArquivoSelected"
        :options="optionsTpArquivo"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <label>Importar documento</label>
      <b-form-file
        v-model="form.file"
        :state="Boolean(form.file)"
        placeholder="Selecione ou arraste o arquivo aqui"
        drop-placeholder="Solte aqui"
      ></b-form-file>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      tpArquivoSelected: [],
      optionsTpArquivo: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      data: [],
      form: new FileForm({
        file: null,
        lay_id: "",
        data: [],
      }),
      helpForm: new Form({
        recordCollection: [],
        docfisCollection: [],
        status: "",
      }),
    };
  },
  watch: {
    tpArquivoSelected(obj) {
      this.form.lay_id = obj.value;
    },
  },

  mounted() {
    this.getLivGeral();
  },

  methods: {
    onImport() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Importação de documento";
      this.modal_botao = "Importar";
      this.modal_acao = "i";
      this.data = [];
      this.$refs.modal_imporatacao_doc.show();
    },

    getLivGeral() {
      this.helpForm
        .get("/api/importacaodocedi/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.layout.forEach((obj) => {
            this.optionsTpArquivo.push({ label: obj.descr, value: obj.lay_id });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },

    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.data.push({ label: "lay_id", value: this.form.lay_id });
      this.data.push({ label: "file", value: this.form.file });
      this.form.data = this.data;
      this.form
        .upload("/api/importacaodocedi/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
  },
};
</script>
